'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".ChatBubble-module_bubbleContainer__z1bbK{display:flex;font-family:helvetica;justify-content:right}.ChatBubble-module_bubbleContainer__z1bbK.ChatBubble-module_narvarUser__SA4Oo{justify-content:left}.ChatBubble-module_chatBubble__eliuj{background-color:#f2f3f5;border-radius:20px 20px 0 20px;color:#2c2f33;display:inline-block;margin:1rem 1.5rem;max-width:70%;padding:.5rem 1rem;word-wrap:break-word}";
var styles = {"bubbleContainer":"ChatBubble-module_bubbleContainer__z1bbK","narvarUser":"ChatBubble-module_narvarUser__SA4Oo","chatBubble":"ChatBubble-module_chatBubble__eliuj"};
styleInject["default"](css_248z, '41ec1629-146a-4f80-9db7-74cd3c4b17fd');

exports["default"] = styles;
